import { useSelector } from "react-redux";
import { StateExtended } from "../../_config/interfaces/stateExtended";

export const useVendorsSelector = () => useSelector((state: StateExtended) => state.vendors.vendors);
